<template>
    <div class="home-component">
        <div class="app-header">
            <img class="session-detail-component-header-logo" src="./../assets/elevate-logo.png" alt="Elevate logo" height="150">
        </div>

        <div class="enter-membership-form">
            <div class="member-log-in-title">
                    新規会員登録
                </div>

            <div class="sign-up-for-membership-page">
                    会員登録がお済みの方は <a href="log-in" class="sign-up-for-membership-page">こちら</a>
                </div>
                <div class="membership-number-text-field-label">
                    名字 (アルファベット)
                </div>
                <div class="membership-number-text-field-container">
                    <input class="membership-number-text-field" id="last-name">
                </div>
                <div class="membership-input">
                <div class="membership-number-text-field-label">
                    名前 (アルファベット)
                </div>
                <div class="membership-number-text-field-container">
                    <input class="membership-number-text-field" id="first-name">
                </div>
                <div class="membership-number-text-field-label">
                    メールアドレス
                </div>
                <div class="membership-number-text-field-container">
                    <input class="membership-number-text-field" id="email">
                </div>
                <div class="membership-number-text-field-label" type="password">
                    パスワード
                </div>
                <div class="membership-number-text-field-container">
                    <input class="membership-number-text-field" id="password" type="password">
                </div>
                <div class="membership-number-text-field-sub-label">
                    パスワードは最低8文字必要です。
                </div>

                <div class="membership-number-text-field-label-blah">
                    会員紹介コード（オプション）
                </div>
                <div class="membership-number-text-field-container">
                    <input class="membership-number-text-field-blah" id="referral">
                </div>
            </div>

            <label class="waiver-check-box-container">
                    <div type="checkbox" name="waiver-check-box" id="waiver-check-box"/>
                    アカウントを新規作成するにあたっては、<a href=https://drive.google.com/file/d/1x4XHllkC_oeM6yzY6rc5jl_uoAro8auw/view?usp target=“_blank” class="waiver-link">利用規約</a>に同意するものとします。<br> <br>
                        
                </label>

            <div class="button-container">
                <button type="button" @click="signUp()" id="membership-number-submit" class="membership-number-submit">登録する</button>
            </div>
        </div>
        
    </div>
</template>

<style scoped>

.waiver-check-box-container {
        font-family:  SFPRoRegular;
        font-size: 12pt;
        color: white;
        margin-bottom: 16px;
        margin-top: 30px;
    }

    .home-component {
        min-height: calc(100vh - 110px);
        display: flex;
        align-items: center;
        justify-content: top;
        flex-direction: column;
        background: rgb(34, 32, 37);
        padding-top: 50pt;
        background-image: url("./../assets/elevate-tiling.png");
    }

    .waiver-link {
        color: white;
        font-family:  SFPRoRegular;
        font-size: 1２pt;
    }

    .button-container {
        display: flex;
         justify-content: center;
    }

    .session-detail-component-header-logo {
        width: 100%;
        height: 120pt;
        object-fit: contain;
    }

    .app-header {
        height: 100pt;
        display: flex;
        justify-content: left;
        align-items: left;
    }

    .enter-membership-form {
        align-items: center;
        justify-content: center;
        max-width: 400px;
        margin-left: 20px;
        margin-right: 20px;
    }
    .membership-number-text-field {
        height: 35px;
        font-family:  SFPRoRegular;
        font-size: 14pt;
        box-sizing: border-box;
        width: 100%;
        margin-bottom: 2pt;
        margin-top: 6pt;
    }

    .membership-number-text-field-blah {
        height: 35px;
        font-family:  SFPRoRegular;
        font-size: 14pt;
        box-sizing: border-box;
        width: 100%;
        margin-bottom: 12pt;
        margin-top: 6pt;
    }

    .home-component-elevate-title {
        font-family: SFPRoBold;
        font-size: 16pt;
    }

    .membership-number-text-field-label {
        font-family: SFPRoBold;
        color: white;
        padding-top: 20pt;
    }

    .membership-number-text-field-label-blah {
        font-family: SFPRoBold;
        color: white;
        padding-top: 16pt;
    }



    .password-number-text-field {
        width: 100%;
        margin-bottom: 2pt;
        margin-top: 6pt;
    }

    .membership-number-text-field-sub-label {
        font-family: SFPRoRegular;
        color: white;
        font-size: 10pt;
        margin-top: 4pt;
    }

    .membership-number-submit {
        height: 40px;
        background-color: rgb(225, 228, 99);
        cursor: pointer;
        border: none;
        border-radius: 8px;
        color: black;
        font-family: SFPRoBold;
        font-size: 16px;
        transition: 300ms;
        width: 150pt;
        align-items: center;
        justify-content: center;
    }

.sign-up-for-membership-page {
    font-family: SFPRoRegular;
    color: white;
    font-size: 14pt;
    margin-top: 5pt;
}

.member-log-in-title {
    font-family: SFPRoBold;
    color: white;
    font-size: 18pt;
    margin-top: 40pt;
    text-align: left;
    display: flex;
}

</style>


<script setup>
    import { useUserStore } from "@/piniastore";
    import { useRouter } from "vue-router";
    import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
    import { db }  from '../main.js'
    import { doc, getDoc, setDoc, collection, query, where, getDocs, addDoc } from "firebase/firestore"; 
    import NProgress from 'nprogress';
    import 'nprogress/nprogress.css';
    const router = useRouter();
 
    function signUp() {
    const firstName = String(document.getElementById("first-name").value);
    const lastName = String(document.getElementById("last-name").value);
    const email = String(document.getElementById("email").value);
    const password = String(document.getElementById("password").value);
    const referralCode = String(document.getElementById("referral").value);

    if (!firstName) {
        alert("名前を入力してください")
        return;
    }

    if (!lastName) {
        alert("名字を入力してください")
        return;
    }

    if (!email) {
        alert("メールアドレスを入力してください")
        return;
    }

    if (!password) {
        alert("パスワードを入力してください")
        return;
    }

    NProgress.start();
    const auth = getAuth();
    const store = useUserStore();
    document.getElementById("membership-number-submit").disabled = true;

    if (referralCode) {
        // User typed referral code, so check if it's valid
        const usersRef = collection(db, "users");
        const queryReferral = query(usersRef, where("referral_code", "==", referralCode.toUpperCase()));

        getDocs(queryReferral)
            .then((response) => {
                if (response.docs.length != 0) {
                    const referralUserID = response.docs[0].id;
                    // Valid code!!

                    getDoc(doc(db, "master-member-number", "FwFRaWVDDmO3as0RvkYJ"))
                        .then((memberNumber) => {
                            const currentMemberNumber = memberNumber.data()['value'];
                            const newMemberNumber = currentMemberNumber + 1;

                            createUserWithEmailAndPassword(auth, email, password)
                                .then((userCredential) => {
                                    setDoc(doc(db, "users", userCredential.user.uid), {
                                        first_name: firstName,
                                        last_name: lastName,
                                        referral_code: String(firstName).toUpperCase() + String(newMemberNumber).padStart(3, '0'),
                                        referred_code: referralCode,
                                        member_number: newMemberNumber
                                    })
                                        .then(() => {
                                            setDoc(doc(db, "master-member-number", "FwFRaWVDDmO3as0RvkYJ"), {
                                                value: newMemberNumber
                                            })
                                                .then(() => {
                                                    addDoc(collection(db, "coupons"), {
                                                        discount: 10,
                                                        is_used: false,
                                                        owner_id: referralUserID,
                                                        title: "Referred coupon"
                                                    })
                                                        .then(() => {
                                                            addDoc(collection(db, "coupons"), {
                                                                discount: 10,
                                                                is_used: false,
                                                                owner_id: userCredential.user.uid,
                                                                title: "Referral coupon"
                                                            })
                                                                .then(() => {
                                                                    getDoc(doc(db, "users", userCredential.user.uid))
                                                                        .then((result) => {
                                                                            store.updateUser(userCredential.user);

                                                                            const referralCode = result.data()['referral_code'];
                                                                            store.updateReferralCode(referralCode);

                                                                            if (store.cameFromEventPage) {
                                                                                router.push('/pre-purchase')
                                                                            } else {
                                                                                router.push('/event-schedule');
                                                                            }
                                                                        
                                                                            document.getElementById("membership-number-submit").disabled = false ;
                                                                            NProgress.done();
                                                                        })
                                                                        .catch((error) => {
                                                                            document.getElementById("membership-number-submit").disabled = false ;
                                                                            NProgress.done()
                                                                            alert(error.message)
                                                                        })
                                                                })
                                                                .catch((error) => {
                                                                    alert(error.message);
                                                                    document.getElementById("membership-number-submit").disabled = false;
                                                                    NProgress.done();
                                                                })

                                                        })
                                                        .catch((error) => {
                                                            alert(error.message);
                                                            document.getElementById("membership-number-submit").disabled = false;
                                                            NProgress.done();
                                                        })

                                                })
                                                .catch((error) => {
                                                    alert(error.message);
                                                    document.getElementById("membership-number-submit").disabled = false;
                                                    NProgress.done();
                                                });
                                        })
                                        .catch((error) => {
                                            alert(error.message);
                                            document.getElementById("membership-number-submit").disabled = false;
                                            NProgress.done();
                                        });
                                })
                                .catch((error) => {
                                    // Handle error if needed
                                    alert(error.message);
                                    document.getElementById("membership-number-submit").disabled = false;
                                    NProgress.done();
                                });
                        });


                } else {
                    alert("紹介コードがどのELEVATE会員とも一致しません。")
                    document.getElementById("membership-number-submit").disabled = false;
                    NProgress.done();
                }
            })
            .catch((error) => {
                alert(error.message);
                document.getElementById("membership-number-submit").disabled = false;
                NProgress.done();
            });

    } else {
        getDoc(doc(db, "master-member-number", "FwFRaWVDDmO3as0RvkYJ"))
            .then((memberNumber) => {
                const currentMemberNumber = memberNumber.data()['value'];
                const newMemberNumber = currentMemberNumber + 1;

                createUserWithEmailAndPassword(auth, email, password)
                    .then((userCredential) => {
                        setDoc(doc(db, "users", userCredential.user.uid), {
                            first_name: firstName,
                            last_name: lastName,
                            referral_code: String(firstName).toUpperCase() + String(newMemberNumber).padStart(3, '0'),
                            referred_code: referralCode,
                            member_number: newMemberNumber
                        })
                            .then(() => {
                                setDoc(doc(db, "master-member-number", "FwFRaWVDDmO3as0RvkYJ"), {
                                    value: newMemberNumber
                                })
                                    .then(() => {
                                        getDoc(doc(db, "users", userCredential.user.uid))
                                                                        .then((result) => {
                                                                            store.updateUser(userCredential.user);

                                                                            const referralCode = result.data()['referral_code'];
                                                                            store.updateReferralCode(referralCode);

                                                                            if (store.cameFromEventPage) {
                                                                                router.push('/pre-purchase')
                                                                            } else {
                                                                                router.push('/event-schedule');
                                                                            }
                                                                        
                                                                            document.getElementById("membership-number-submit").disabled = false ;
                                                                            NProgress.done();
                                                                        })
                                                                        .catch((error) => {
                                                                            document.getElementById("membership-number-submit").disabled = false ;
                                                                            NProgress.done()
                                                                            alert(error.message)
                                                                        })
                                    })
                                    .catch((error) => {
                                        alert(error.message);
                                        document.getElementById("membership-number-submit").disabled = false;
                                        NProgress.done();
                                    });
                            })
                            .catch((error) => {
                                alert(error.message);
                                document.getElementById("membership-number-submit").disabled = false;
                                NProgress.done();
                            });
                    })
                    .catch((error) => {
                        // Handle error if needed
                        alert(error.message);
                        document.getElementById("membership-number-submit").disabled = false;
                        NProgress.done();
                    });
            });
    }
}
</script>

<script>
export default {
    mounted () {
        window.scrollTo(0, 0);
    }
}
</script>